import React, { useState } from "react";
import { Box, Button, Dialog } from "@mui/material";
import { DialogContent, Stack, TextField, Typography } from "@mui/material";
import Repo from "../../Repository/Repo";
import ClipLoader from "react-spinners/ClipLoader";
import { Toast } from "../components/Toast";

function AddUser({ onClose, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [isRegistered, setIsRegistered] = useState(false);
  const [state, setState] = useState({
    username: "",
    id: "",
    companyCode: "",
  });

  const toggle = () => {
    if (!loading) {
      onClose();
    }
  };

  const handleRegister = async () => {
    try {
      setLoading(true);

      let id = Math.floor(Math.random() * 9000 + 1000);
      const { data } = await Repo.user({
        request: {
          method: "saveUser",
          data: {
            user: {
              username: state.username,
              _id: id.toString(),
              company_code: state.companyCode,
            },
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusMessage == "OK") {
        setIsRegistered(true);
        setState((prev) => ({ ...prev, id }));
        Toast("success", "Employee added successfully");
      } else {
        Toast("error", data.response.status.statusMessage);
      }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <Dialog open={true} onClose={toggle} fullWidth maxWidth="xs">
      <DialogContent>
        {!isRegistered && (
          <Stack spacing="24px">
            <Typography variant="h6" sx={{ textAlign: "center" }}>
              Add new Employee
            </Typography>
            <TextField
              autoFocus
              label="User Name"
              type="text"
              size="small"
              fullWidth
              variant="outlined"
              name="username"
              value={state.username}
              onChange={handleInput}
            />
            <TextField
              label="Company Code"
              type="number"
              size="small"
              fullWidth
              variant="outlined"
              name="companyCode"
              value={state.companyCode}
              onChange={handleInput}
            />

            {loading && (
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <ClipLoader size={33} color="#4DAF51" loading={true} />
              </Box>
            )}
            {!loading && (
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  variant="contained"
                  sx={{
                    textTransform: "none",
                    background: "rgb(138, 138, 138) !important",
                  }}
                  onClick={toggle}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  sx={{ textTransform: "none" }}
                  onClick={handleRegister}
                >
                  Register
                </Button>
              </Box>
            )}
          </Stack>
        )}
        {isRegistered && (
          <Stack spacing="24px">
            <Typography
              variant="h6"
              sx={{ textAlign: "center", color: "#4eaf51" }}
            >
              Registered Successfully
            </Typography>
            <Stack width="100%" alignItems="center" justifyContent="center">
              <Stack direction="row" spacing="8px">
                <Typography sx={{ textAlign: "center" }}>
                  User Name :
                </Typography>
                <Typography sx={{ textAlign: "center", color: "#4eaf51" }}>
                  {state.username}
                </Typography>
              </Stack>
              <Stack direction="row" spacing="8px">
                <Typography sx={{ textAlign: "center" }}>User ID :</Typography>
                <Typography sx={{ textAlign: "center", color: "#4eaf51" }}>
                  {state.id}
                </Typography>
              </Stack>
            </Stack>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                sx={{
                  textTransform: "none",
                  background: "rgb(138, 138, 138) !important",
                }}
                onClick={onSuccess}
              >
                Close
              </Button>
            </Box>
          </Stack>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default AddUser;
